export class GenericListIconDefinition {
  icon: string;

  constructor(icon: string) {
    this.icon = icon;
  }
}
